import { assocPath, maybeNumber } from "../../js/lib/functional.js";

const keyToPath = key => key.split(".").map(maybeNumber);

const reducer = (acc, [key, value]) => assocPath(keyToPath(key), value, acc);

export const convert = metadata => Object.entries(metadata).reduce(reducer, {});
